export const ApplyVipArr = [
  {
    path: "vip",
    name: "vip",
    meta: {
      title: "会员卡"
    },
    redirect: "/apply/vip/vipIndex",
    children: [
      {
        path: "vipIndex",
        name: "vipIndex",
        meta: {
          title: "概况"
        },
        component: () => import("@/views/apply/vip/vipIndex")
      },
      {
        path: "appointManage",
        name: "appointManage",
        meta: {
          title: "文章管理"
        },
        component: () => import("@/views/apply/vip/appointManage")
      },
      {
        path: "advertising",
        name: "advertising",
        meta: {
          title: "广告管理"
        },
        component: () => import("@/views/apply/vip/advertising")
      },
      {
        path: "noticeManage",
        name: "noticeManage",
        meta: {
          title: "公告管理"
        },
        component: () => import("@/views/apply/vip/noticeManage")
      }
    ]
  },
  // 新会员卡
  {
    path: "newVip/:id(\\d+)",
    name: "newVip/:id(\\d+)",
    meta: {
      title: "会员卡"
    },
    redirect: "/apply/newVip/:id(\\d+)/home/vipIndex",
    component: () => import("@/views/sidebar/itemFrame.vue"),
    children: [
      {
        path: "home",
        name: "home",
        meta: {
          title: "功能首页"
        },
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "vipIndex",
            name: "vipIndex",
            meta: {
              title: "会员首页"
            },
            component: () => import("@/views/apply/newVip/home/vipIndex")
          },
          {
            path: "wxCard",
            name: "wxCard",
            meta: {
              title: "微信卡券"
            },
            component: () => import("@/views/apply/newVip/addVipUser/showCard")
          },
          {
            path: "miniCard",
            name: "miniCard",
            meta: {
              title: "小程序卡券"
            },
            component: () => import("@/views/apply/newVip/addVipUser/miniCard")
          },
          {
            path: "openMiniCard",
            name: "openMiniCard",
            meta: {
              title: "创建小程序卡券"
            },
            component: () =>
              import("@/views/apply/newVip/addVipUser/openMiniCard")
          },
          {
            path: "mywxard",
            name: "mywxard",
            meta: {
              title: "我的卡券"
            },
            component: () => import("@/views/apply/newVip/addVipUser/index")
          },
          {
            path: "openCard",
            name: "openCard",
            meta: {
              title: "会员开卡"
            },
            component: () => import("@/views/apply/newVip/home/openCard")
          },
          {
            path: "customerBack",
            name: "customerBack",
            meta: {
              title: "客户召回"
            },
            component: () => import("@/views/apply/newVip/home/customerBack")
          },
          {
            path: "scanVerification",
            name: "scanVerification",
            meta: {
              title: "扫码核销"
            },
            component: () =>
              import("@/views/apply/newVip/home/scanVerification")
          },
          {
            path: "changeDuty",
            name: "changeDuty",
            meta: {
              title: "交班"
            },
            component: () => import("@/views/apply/newVip/home/changeDuty")
          },
          {
            path: "changeDutyDetail",
            name: "changeDutyDetail",
            meta: {
              title: "交班"
            },
            component: () =>
              import("@/views/apply/newVip/home/changeDutyDetail")
          },
          {
            path: "changeDutyList",
            name: "changeDutyList",
            meta: {
              title: "交班记录"
            },
            component: () => import("@/views/apply/newVip/home/changeDutyList")
          },
          {
            path: "royalties",
            name: "royalties",
            meta: {
              title: "员工提成"
            },
            component: () => import("@/views/apply/newVip/home/commission")
          },
          {
            path: "royaltiesSet",
            name: "royaltiesSet",
            meta: {
              title: "员工提成"
            },
            component: () => import("@/views/apply/newVip/home/royalties")
          },
          {
            path: "royaltiesSet1",
            name: "royaltiesSet1",
            meta: {
              title: "员工提成"
            },
            component: () => import("@/views/apply/newVip/home/commissionSet")
          },
          {
            path: "changeDutyNew",
            name: "changeDutyNew",
            meta: {
              title: "交班"
            },
            component: () => import("@/views/apply/newVip/home/changeDutyNew")
          },
          {
            path: "staff_handover",
            name: "staff_handover",
            meta: {
              title: "员工交班"
            },
            component: () => import("@/views/apply/newVip/home/staff_handover")
          },
          {
            path: "changeDutyNew2",
            name: "changeDutyNew2",
            meta: {
              title: "交班"
            },
            component: () => import("@/views/apply/newVip/home/changeDutyNew2")
          },
          {
            path: "noticeInfo",
            name: "noticeInfo",
            meta: {
              title: "公告详情"
            },
            component: () => import("@/views/apply/newVip/home/notice_info")
          }
        ]
      },
      {
        path: "shop",
        name: "shop",
        meta: {
          title: "门店"
        },
        component: {
          render: c => c("router-view")
        },
        redirect: "/apply/newVip/13/shop/shopList",
        children: [
          {
            path: "shopList",
            name: "shopList",
            meta: {
              title: "门店列表"
            },
            component: () => import("@/views/apply/newVip/shop/shopList")
          },
          {
            path: "addStore",
            name: "addStore",
            meta: {
              title: "门店设置"
            },
            component: () => import("@/views/apply/newVip/shop/shopAdd")
          }
        ]
      },
      //便利店
      {
        path: "convenience_store",
        name: "convenience_store",
        meta: {
          title: "便利店"
        },
        redirect: "/apply/newVip/13/convenience_store/index",
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "index",
            name: "index",
            meta: {
              title: "商品列表"
            },
            component: () => import("@/views/apply/newVip/convenience_store")
          },
          {
            path: "add",
            name: "add",
            meta: {
              title: "添加商品"
            },
            component: () =>
              import("@/views/apply/newVip/convenience_store/add_goods")
          },
          {
            path: "order",
            name: "order",
            meta: {
              title: "商品订单"
            },
            component: () =>
              import("@/views/apply/newVip/convenience_store/goods_order")
          },
          {
            path: "edit",
            name: "edit",
            meta: {
              title: "商品编辑"
            },
            component: () =>
              import("@/views/apply/newVip/convenience_store/edit_goods")
          }
        ]
      },
      //任务活动

      {
        path: "market",
        name: "market",
        meta: {
          title: "营销"
        },
        redirect: "/apply/newVip/13/market/index",
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "index",
            name: "index",
            meta: {
              title: "营销中心"
            },
            component: () => import("@/views/apply/newVip/market")
          },
          {
            path: "marketing",
            name: "marketing",
            meta: {
              title: "活动"
            },
            component: () => import("@/views/apply/newVip/marketing/home"),
            children: [
              {
                path: "gift/:inline",
                name: "gift/:inline",
                redirect: "gift/inlineGift/list",
                meta: {
                  title: "赠品管理"
                },
                component: () => import("@/views/sidebar/inlineItemFrame"),
                children: [
                  {
                    path: "list",
                    name: "list",
                    meta: {
                      title: "赠品列表"
                    },
                    component: () =>
                      import(
                        "@/views/apply/newVip/business/refuel/gift/giftList"
                      )
                  },
                  {
                    path: "ruleList",
                    name: "ruleList",
                    meta: {
                      title: "赠品规则"
                    },
                    component: () =>
                      import(
                        "@/views/apply/newVip/business/refuel/gift/rule/ruleList"
                      )
                  },
                  {
                    path: "ruleAd",
                    name: "ruleAd",
                    meta: {
                      title: "增加赠品规则"
                    },
                    component: () =>
                      import(
                        "@/views/apply/newVip/business/refuel/gift/rule/ruleAd"
                      )
                  },
                  {
                    path: "record",
                    name: "record",
                    meta: {
                      title: "赠品记录"
                    },
                    component: () =>
                      import("@/views/apply/newVip/business/refuel/gift/record")
                  }
                ]
              },
              {
                path: "client",
                name: "client",
                meta: {
                  title: "客户营销"
                },
                component: {
                  render: c => c("router-view")
                },
                children: [
                  {
                    path: "rechargeSet",
                    name: "rechargeSet",
                    meta: {
                      title: "充值赠送设置"
                    },
                    component: () =>
                      import("@/views/apply/newVip/business/rechargeSet/index")
                  },
                  {
                    path: "consumption",
                    name: "consumption",
                    meta: {
                      title: "消费后有礼"
                    },
                    component: {
                      render: c => c("router-view")
                    },
                    children: [
                      {
                        path: "consumption-list",
                        name: "consumption-list",
                        meta: {
                          title: "消费后有礼"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/consumption/index"
                          )
                      },
                      {
                        path: "consumption-set",
                        name: "consumption-set",
                        meta: {
                          title: "添加消费后有礼"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/consumption/set"
                          )
                      }
                    ]
                  },
                  {
                    path: "birthday",
                    name: "birthday",
                    meta: {
                      title: "生日有礼"
                    },
                    component: {
                      render: c => c("router-view")
                    },
                    children: [
                      {
                        path: "birthday-list",
                        name: "birthday-list",
                        meta: {
                          title: "生日有礼"
                        },
                        component: () =>
                          import("@/views/apply/newVip/refuel/client/birthday")
                      },
                      {
                        path: "birthday-set",
                        name: "birthday-set",
                        meta: {
                          title: "添加生日有礼"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/birthday/set"
                          )
                      }
                    ]
                  },
                  {
                    path: "rechange",
                    name: "rechange",
                    meta: {
                      title: "充值有礼"
                    },
                    component: {
                      render: c => c("router-view")
                    },
                    children: [
                      {
                        path: "rechange-list",
                        name: "rechange-list",
                        meta: {
                          title: "充值有礼"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/rechange/index"
                          ) //旧版为index1
                      },
                      {
                        path: "rechange-set",
                        name: "rechange-set",
                        meta: {
                          title: "添加充值有礼"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/rechange/set" //旧版为set1
                          )
                      }
                    ]
                  },
                  {
                    path: "invite",
                    name: "invite",
                    meta: {
                      title: "邀请有礼"
                    },
                    component: {
                      render: c => c("router-view")
                    },
                    children: [
                      {
                        path: "inviteList",
                        name: "inviteList",
                        meta: {
                          title: "邀请有礼"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/marketing/invite/inviteList"
                          )
                      },
                      {
                        path: "invite",
                        name: "invite",
                        meta: {
                          title: "邀请有礼"
                        },
                        component: () =>
                          import("@/views/apply/newVip/marketing/invite/invite")
                      }
                    ]
                  },

                  {
                    path: "lottery",
                    name: "lottery",
                    meta: {
                      title: "抽奖活动"
                    },
                    component: {
                      render: c => c("router-view")
                    },
                    children: [
                      {
                        path: "index",
                        name: "index",
                        meta: {
                          title: "抽奖活动"
                        },
                        component: () =>
                          import("@/views/apply/newVip/marketing/lottery/index")
                      },
                      {
                        path: "turntable",
                        name: "turntable",
                        meta: {
                          title: "抽奖信息"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/marketing/lottery/turntable"
                          )
                      },
                      {
                        path: "winningList",
                        name: "winningList",
                        meta: {
                          title: "中奖信息"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/marketing/lottery/winningList"
                          )
                      },
                      {
                        path: "winningInfo",
                        name: "winningInfo",
                        meta: {
                          title: "中奖详情"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/marketing/lottery/winning_Details"
                          )
                      },
                      {
                        path: "statistics",
                        name: "statistics",
                        meta: {
                          title: "抽奖活动"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/marketing/lottery/statistics"
                          )
                      }
                    ]
                  },
                  {
                    path: "activity_Douyin",
                    name: "activity_Douyin",
                    meta: {
                      title: "抖音活动"
                    },
                    component: {
                      render: c => c("router-view")
                    },
                    children: [
                      {
                        path: "index",
                        name: "index",
                        meta: {
                          title: "抖音活动列表"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/marketing/activity_Douyin/index"
                          )
                      },

                      {
                        path: "add_Douyin",
                        name: "add_Douyin",
                        meta: {
                          title: "活动信息-第一步"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/marketing/activity_Douyin/add_Douyin"
                          )
                      },
                      {
                        path: "set_activity",
                        name: "set_activity",
                        meta: {
                          title: "活动规则-第二步"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/marketing/activity_Douyin/set_activity"
                          )
                      },
                      {
                        path: "Dy_statistics",
                        name: "Dy_statistics",
                        meta: {
                          title: "活动统计"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/marketing/activity_Douyin/statistics"
                          )
                      }
                    ]
                  },
                  {
                    path: "holiday",
                    name: "holiday",
                    meta: {
                      title: "节日有礼"
                    },
                    component: {
                      render: c => c("router-view")
                    },
                    children: [
                      {
                        path: "holiday-list",
                        name: "holiday-list",
                        meta: {
                          title: "节日有礼"
                        },
                        component: () =>
                          import("@/views/apply/newVip/refuel/client/holiday")
                      },
                      {
                        path: "holiday-set",
                        name: "holiday-set",
                        meta: {
                          title: "添加节日有礼"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/holiday/set"
                          )
                      }
                    ]
                  },
                  {
                    path: "dispersion",
                    name: "dispersion",
                    meta: {
                      title: "散客设置"
                    },
                    component: {
                      render: c => c("router-view")
                    },
                    children: [
                      {
                        path: "dispersion_input",
                        name: "dispersion_input",
                        meta: {
                          title: "散客设置"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/marketing/dispersion/index_input"
                          )
                      }
                    ]
                  },
                  {
                    path: "sign/:inline",
                    name: "sign",
                    meta: {
                      title: "签到"
                    },
                    redirect: "sign/:inline/set",
                    component: () => import("@/views/sidebar/inlineItemFrame"),
                    children: [
                      {
                        path: "set",
                        name: "set",
                        meta: {
                          title: "签到规则设置"
                        },
                        component: () =>
                          import("@/views/apply/comModule/sign/set.vue")
                      },
                      {
                        path: "signList",
                        name: "signList",
                        meta: {
                          title: "签到记录"
                        },
                        component: () =>
                          import("@/views/apply/comModule/sign/signgList.vue")
                      }
                    ]
                  },
                  {
                    path: "message",
                    name: "message",
                    meta: {
                      title: "消息通知"
                    },
                    component: {
                      render: c => c("router-view")
                    },
                    children: [
                      {
                        path: "message-list",
                        name: "message-list",
                        meta: {
                          title: "消息通知"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/message/index"
                          )
                      },
                      {
                        path: "message-recharge",
                        name: "message-recharge",
                        meta: {
                          title: "消息通知订购"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/message/recharge"
                          )
                      },
                      {
                        path: "message-submit",
                        name: "message-submit",
                        meta: {
                          title: "消息通知订购提交"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/message/submit"
                          )
                      },
                      {
                        path: "message-callBack",
                        name: "message-callBack",
                        meta: {
                          title: "消息通知订购回调"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/message/callBack"
                          )
                      },
                      {
                        path: "message-order",
                        name: "message-order",
                        meta: {
                          title: "我的订单"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/message/order"
                          )
                      }
                    ]
                  },
                  {
                    path: "integral",
                    name: "integral",
                    meta: {
                      title: "积分联盟"
                    },
                    component: () =>
                      import(
                        "@/views/apply/newVip/refuel/client/integral/index"
                      ),
                    children: [
                      {
                        path: "integral-list",
                        name: "integral-list",
                        meta: {
                          title: "积分联盟"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/integral/integral_list"
                          )
                      },
                      {
                        path: "integral-audit",
                        name: "integral-audit",
                        meta: {
                          title: "联盟审核"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/integral/integral_audit"
                          )
                      },
                      {
                        path: "point-goods",
                        name: "point-goods",
                        meta: {
                          title: "积分商品"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/integral/point_goods"
                          )
                      },
                      {
                        path: "point-order",
                        name: "point-order",
                        meta: {
                          title: "积分订单"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/integral/point_order"
                          )
                      },
                      {
                        path: "optionProduct",
                        name: "optionProduct",
                        meta: {
                          title: "积分订单"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/integral/optionProduct.vue"
                          )
                      }
                    ]
                  },
                  {
                    path: "attention",
                    name: "attention",
                    meta: {
                      title: "关注有礼"
                    },
                    component: {
                      render: c => c("router-view")
                    },
                    children: [
                      {
                        path: "attention-list",
                        name: "attention-list",
                        meta: {
                          title: "关注有礼"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/attention/index"
                          )
                      },
                      {
                        path: "attention-set",
                        name: "attention-set",
                        meta: {
                          title: "添加关注有礼"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/attention/set"
                          )
                      }
                    ]
                  },
                  {
                    path: "note",
                    name: "note",
                    meta: {
                      title: "短信群发"
                    },
                    component: {
                      render: c => c("router-view")
                    },
                    children: [
                      {
                        path: "note-list",
                        name: "note-list",
                        meta: {
                          title: "短信群发"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/note/index"
                          )
                      },
                      {
                        path: "note-set",
                        name: "note-set",
                        meta: {
                          title: "添加短信群发"
                        },
                        component: () =>
                          import("@/views/apply/newVip/refuel/client/note/set")
                      }
                    ]
                  },
                  {
                    path: "active",
                    name: "active",
                    meta: {
                      title: "群发服务设置"
                    },
                    component: () =>
                      import("@/views/apply/newVip/refuel/client/active/index")
                  },
                  {
                    path: "group_points",
                    name: "group_points",
                    meta: {
                      title: "群发积分模板"
                    },
                    component: () =>
                      import("@/views/apply/newVip/refuel/client/sendPoint/group_points")
                  },
                  {
                    path: "sendPoint",
                    name: "sendPoint",
                    meta: {
                      title: "群发积分模板"
                    },
                    component: () =>
                      import("@/views/apply/newVip/refuel/client/sendPoint/sendPoint")
                  },
                  {
                    path: "activeAdd",
                    name: "activeAdd",
                    meta: {
                      title: "群发服务设置"
                    },
                    component: () =>
                      import("@/views/apply/newVip/refuel/client/active/add")
                  },
                  {
                    path: "push",
                    name: "push",
                    meta: {
                      title: "推送服务"
                    },
                    component: () =>
                      import("@/views/apply/newVip/refuel/client/push/index"),
                    children: [
                      {
                        path: "activeIndex",
                        name: "activeIndex",
                        meta: {
                          title: "活跃粉丝推送"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/push/active/index"
                          )
                      },
                      {
                        path: "activeHome",
                        name: "activeHome",
                        meta: {
                          title: "活跃粉丝推送"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/push/active/home"
                          )
                      },
                      // {
                      //   path: "moduleIndex",
                      //   name: "moduleIndex",
                      //   meta: {
                      //     title: "模板消息推送"
                      //   },
                      //   component: () =>
                      //     import(
                      //       // "@/views/apply/newVip/refuel/client/push/module/index"
                      //     )
                      // },
                      {
                        path: "smartIndex",
                        name: "smartIndex",
                        meta: {
                          title: "智能推送"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/push/smart/index"
                          )
                      },
                      {
                        path: "smartHome",
                        name: "smartHome",
                        meta: {
                          title: "智能推送"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/push/smart/home"
                          )
                      },
                      {
                        path: "resource",
                        name: "resource",
                        meta: {
                          title: "资源库管理"
                        },
                        component: () =>
                          import(
                            "@/views/apply/newVip/refuel/client/push/resource"
                          )
                      }
                    ]
                  }
                ]
              },
              // 促销活动
              {
                path: "salesPromotion",
                name: "salesPromotion",
                meta: {
                  title: "促销活动"
                },
                component: {
                  render: c => c("router-view")
                },
                children: [
                  {
                    path: "promoCode",
                    name: "promoCode",
                    meta: {
                      title: "优惠码"
                    },
                    component: () =>
                      import(
                        "@/views/apply/newVip/business/refuel/salesPromotion/promoCode"
                      )
                  },
                  {
                    path: "addShopLabel",
                    name: "addShopLabel",
                    meta: {
                      title: "添加优惠码"
                    },
                    component: () =>
                      import(
                        "@/views/apply/newVip/business/refuel/salesPromotion/addShopLabel.vue"
                      )
                  },
                  {
                    path: "discount",
                    name: "discount",
                    meta: {
                      title: "限时折扣"
                    },
                    component: () =>
                      import(
                        "@/views/apply/newVip/business/refuel/salesPromotion/discount"
                      )
                  },
                  {
                    path: "addDiscountRule",
                    name: "addDiscountRule",
                    meta: {
                      title: "添加限时折扣"
                    },
                    component: () =>
                      import(
                        "@/views/apply/newVip/business/refuel/salesPromotion/addDiscountRule"
                      )
                  },
                  {
                    path: "pointSetting",
                    name: "pointSetting",
                    meta: {
                      title: "积分抵扣"
                    },
                    component: () =>
                      import(
                        "@/views/apply/newVip/business/refuel/salesPromotion/pointSetting"
                      )
                  },
                  {
                    path: "pointSetting_set",
                    name: "pointSetting_set",
                    meta: {
                      title: "积分抵扣规则设置"
                    },
                    component: () =>
                      import("@/views/apply/pointSetting/pointSetting_2")
                  },
                  // 套壳子
                  {
                    path: "shellDiscount",
                    name: "shellDiscount",
                    meta: {
                      title: "优惠券"
                    },
                    component: () =>
                      import("@/views/apply/newVip/marketing/shell/discount")
                  },
                  {
                    path: "optionTicket",
                    name: "optionTicket",
                    meta: {
                      title: "添加优惠券"
                    },
                    component: () =>
                      import(
                        "@/views/apply/comModule/coupon/ticket/adticket.vue"
                      )
                  },
                  {
                    path: "statisticsCoupon",
                    name: "statisticsCoupon",
                    meta: {
                      title: "优惠券统计"
                    },
                    component: () =>
                      import(
                        "@/views/apply/comModule/coupon/ticket/statisticsCoupon.vue"
                      )
                  },
                  {
                    path: "discounts",
                    name: "discounts",
                    meta: {
                      title: "优惠券核销"
                    },
                    component: () =>
                      import(
                        "@/views/apply/comModule/coupon/ticket/discounts.vue"
                      )
                  },
                  {
                    path: "grant",
                    name: "grant",
                    meta: {
                      title: "优惠券领取记录"
                    },
                    component: () =>
                      import("@/views/apply/comModule/coupon/ticket/grant.vue")
                  },
                  {
                    path: "shellIntegral",
                    name: "shellIntegral",
                    meta: {
                      title: "积分商城"
                    },
                    component: () =>
                      import(
                        "@/views/apply/comModule/integralMall/commodity/prodduct/index.vue"
                      )
                  },
                  // {
                  //   path: "addcategory",
                  //   name: "addcategory",
                  //   meta: {
                  //     title: "商品类目"
                  //   },
                  //   component: () =>
                  //     import(
                  //       "@/views/apply/comModule/integralMall/commodity/prodduct/addcategory.vue"
                  //     )
                  // },
                  // {
                  //   path: "exchangeRecord",
                  //   name: "exchangeRecord",
                  //   meta: {
                  //     title: "兑换记录"
                  //   },
                  //   component: () =>
                  //     import(
                  //       "@/views/apply/comModule/integralMall/commodity/prodduct/addcategory.vue"
                  //     )
                  // },
                  {
                    path: "optionProdduct",
                    name: "optionProdduct",
                    meta: {
                      title: "积分商品"
                    },
                    component: () =>
                      import(
                        "@/views/apply/comModule/integralMall/commodity/prodduct/adproduct.vue"
                      )
                  },
                  {
                    path: "integralTask",
                    name: "integralTask",
                    meta: {
                      title: "消分任务设置"
                    },
                    component: () =>
                      import(
                        "@/views/apply/newVip/refuel/client/integralTask/index"
                      )
                  },
                  {
                    path: "integralTaskAdd",
                    name: "integralTaskAdd",
                    meta: {
                      title: "消分任务设置"
                    },
                    component: () =>
                      import(
                        "@/views/apply/newVip/refuel/client/integralTask/add"
                      )
                  },
                  {
                    path: "Mission_activities",
                    name: "Mission_activities",
                    meta: {
                      title: "任务活动"
                    },
                    component: {
                      render: c => c("router-view")
                    },
                    children: [
                      {
                        path: "index",
                        name: "index",
                        meta: {
                          title: "任务活动列表"
                        },
                        component: () =>
                          import("@/views/apply/newVip/Mission_activities")
                      },
                      {
                        path: "add",
                        name: "add",
                        meta: {
                          title: "添加"
                        },
                        component: () =>
                          import("@/views/apply/newVip/Mission_activities/add")
                      },
                      {
                        path: "edit",
                        name: "edit",
                        meta: {
                          title: "编辑"
                        },
                        component: () =>
                          import("@/views/apply/newVip/Mission_activities/edit")
                      },
                      {
                        path: "info",
                        name: "info",
                        meta: {
                          title: "详情"
                        },
                        component: () =>
                          import("@/views/apply/newVip/Mission_activities/info")
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },

      {
        path: "business",
        name: "business",
        meta: {
          title: "业务"
        },
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "getMoney",
            name: "getMoney",
            meta: {
              title: "收银消费"
            },
            component: () =>
              import("@/views/apply/newVip/business/charging/getMoney")
          },
          {
            path: "recharge",
            name: "recharge",
            meta: {
              title: "快速充值"
            },
            component: () =>
              import("@/views/apply/newVip/business/charging/recharge")
          },
          {
            path: "integral",
            name: "integral",
            meta: {
              title: "积分兑换"
            },
            component: () =>
              import("@/views/apply/newVip/business/charging/integral")
          },
          //便利店
          {
            path: "convenience",
            name: "convenience",
            meta: {
              title: "便利店"
            },
            component: () =>
              import("@/views/apply/newVip/business/charging/convenience")
          },

          {
            path: "meal_list",
            name: "meal_list",
            meta: {
              title: "套餐列表"
            },
            component: () => import("@/views/apply/newVip/business/meal/list")
          },
          {
            path: "admeal",
            name: "admeal",
            meta: {
              title: "设置套餐"
            },
            component: () => import("@/views/apply/newVip/business/meal/admeal")
          },
          {
            path: "addActivity",
            name: "addActivity",
            meta: {
              title: "添加活动"
            },
            component: () =>
              import("@/views/apply/newVip/business/activity/addActivity")
          },
          {
            path: "actlist",
            name: "actlist",
            meta: {
              title: "活动列表"
            },
            component: () =>
              import("@/views/apply/newVip/business/activity/actlist")
          },
          {
            path: "yuelist",
            name: "yuelist",
            meta: {
              title: "预约列表"
            },
            component: () =>
              import("@/views/apply/newVip/business/subscribe/index")
          },
          {
            path: "setyue",
            name: "setyue",
            meta: {
              title: "预约设置"
            },
            component: () =>
              import("@/views/apply/newVip/business/subscribe/setIndex")
          },
          {
            path: "couponTaskList",
            name: "couponTaskList",
            meta: {
              title: "任务"
            },
            component: () =>
              import("@/views/apply/newVip/business/couponTask/taskList")
          }
        ]
      },
      {
        path: "xuanpinku",
        name: "xuanpinku",
        meta: {
          title: "选品库"
        },
        component: {
          render: c => c("router-view")
        },
        redirect: "/apply/newVip/13/xuanpinku/xuanpin",
        children: [
          {
            path: "xuanpin",
            name: "xuanpin",
            meta: {
              title: "首页"
            },
            component: () =>
              import(
                "@/views/apply/comModule/integralMall/commodity/xuanpinku/index.vue"
              )
          },
          {
            path: "Prepaid",
            name: "Prepaid",
            meta: {
              title: "余额支付"
            },
            component: () =>
              import(
                "@/views/apply/comModule/integralMall/commodity/xuanpinku/Prepaid.vue"
              )
          },
          {
            path: "checkgoods",
            name: "checkgoods",
            meta: {
              title: "选品平台"
            },
            component: () =>
              import(
                "@/views/apply/comModule/integralMall/commodity/xuanpinku/checkgoods.vue"
              )
          },
          {
            path: "integral_set",
            name: "integral_set",
            meta: {
              title: "比例设置"
            },
            component: () =>
              import(
                "@/views/apply/comModule/integralMall/commodity/xuanpinku/integral_set.vue"
              )
          },
          {
            path: "orderList",
            name: "orderList",
            meta: {
              title: "订单"
            },
            component: () =>
              import(
                "@/views/apply/comModule/integralMall/commodity/xuanpinku/order.vue"
              )
          },
          {
            path: "orderInfo",
            name: "orderInfo",
            meta: {
              title: "订单信息"
            },
            component: () =>
              import(
                "@/views/apply/comModule/integralMall/commodity/xuanpinku/orderInfo.vue"
              )
          },
          {
            path: "settlement",
            name: "settlement",
            meta: {
              title: "结算"
            },
            component: () =>
              import(
                "@/views/apply/comModule/integralMall/commodity/xuanpinku/settlement.vue"
              )
          },
          {
            path: "settlement_logs",
            name: "settlement_logs",
            meta: {
              title: "记录明细"
            },
            component: () =>
              import(
                "@/views/apply/comModule/integralMall/commodity/xuanpinku/loglist.vue"
              )
          },
          {
            path: "settlement_logs2",
            name: "settlement_logs2",
            meta: {
              title: "结算记录"
            },
            component: () =>
              import(
                "@/views/apply/comModule/integralMall/commodity/xuanpinku/settlementList.vue"
              )
          }
        ]
      },
      {
        path: "order",
        name: "order",
        meta: {
          title: "订单"
        },
        component: {
          render: c => c("router-view")
        },
        redirect: "/apply/newVip/13/order/oilsListNow",
        children: [
          {
            path: "index",
            name: "index",
            meta: {
              title: "概览"
            },
            component: () => import("@/views/apply/newVip/order/index")
          },
          {
            path: "voucherList",
            name: "voucherList",
            meta: {
              title: "充值订单"
            },
            component: () => import("@/views/apply/newVip/order/voucherList")
          },
          {
            path: "balanceLog",
            name: "balanceLog",
            meta: {
              title: "余额记录"
            },
            component: () => import("@/views/apply/newVip/order/balanceLog")
          },
          {
            path: "pointLog",
            name: "pointLog",
            meta: {
              title: "积分记录"
            },
            component: () => import("@/views/apply/newVip/order/pointLog")
          },
          {
            path: "oilsList",
            name: "oilsList",
            meta: {
              title: "油品销售数据"
            },
            component: () => import("@/views/apply/newVip/order/oilsList")
          },
          {
            path: "oilsListNow",
            name: "oilsListNow",
            meta: {
              title: "当前班次订单"
            },
            component: () => import("@/views/apply/newVip/order/oilsListNow")
          },
          {
            path: "recentShift",
            name: "recentShift",
            meta: {
              title: "最近班次订单"
            },
            component: () => import("@/views/apply/newVip/order/recentShift")
          },
          {
            path: "ordinaryList",
            name: "ordinaryList",
            meta: {
              title: "普通订单"
            },
            component: () => import("@/views/apply/newVip/order/ordinaryList")
          },
          {
            path: "refundList",
            name: "refundList",
            meta: {
              title: "订单退款列表"
            },
            component: () => import("@/views/apply/newVip/order/refundList")
          },
          {
            path: "orderDelteList",
            name: "orderDelteList",
            meta: {
              title: "订单删除列表"
            },
            component: () => import("@/views/apply/newVip/order/orderDelteList")
          },
          {
            path: "discountsVerification",
            name: "discountsVerification",
            meta: {
              title: "优惠券核销记录"
            },
            component: () =>
              import("@/views/apply/newVip/order/discountsVerification")
          },
          {
            path: "shellIntegral",
            name: "shellIntegral",
            meta: {
              title: "积分商城"
            },
            component: () =>
              import("@/views/apply/comModule/integralMall/order/index.vue")
          },
          {
            path: "shopOrder",
            name: "shopOrder",
            meta: {
              title: "非油品订单"
            },
            component: () => import("@/views/apply/newVip/order/shopOrder")
          },
          {
            path: "orderDetails",
            name: "orderDetails",
            meta: {
              title: "非油品订单"
            },
            component: () =>
              import("@/views/apply/newVip/order/shopOrderDetail")
          }
        ]
      },
      {
        path: "set",
        name: "set",
        meta: {
          title: "设置"
        },
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "tlpay_set",
            name: "tlpay_set",
            meta: {
              title: "多账户设置"
            },
            component: () => import("@/views/apply/newVip/setting/tlpay_set")
          },
          {
            path: "employee",
            name: "employee",
            meta: {
              title: "员工设置"
            },
            component: () => import("@/views/apply/newVip/setting/employee")
          },
          {
            path: "employeeAdd",
            name: "employeeAdd",
            meta: {
              title: "员工设置"
            },
            component: () => import("@/views/apply/newVip/setting/employeeAdd")
          },
          {
            path: "role",
            name: "role",
            meta: {
              title: "角色设置"
            },
            component: () => import("@/views/apply/newVip/setting/role")
          },
          {
            path: "roleAdd",
            name: "roleAdd",
            meta: {
              title: "角色设置"
            },
            component: () => import("@/views/apply/newVip/setting/roleAdd")
          },
          {
            path: "compose",
            name: "compose",
            meta: {
              title: "排班设置"
            },
            component: {
              render: c => c("router-view")
            },
            children: [
              {
                path: "classList",
                name: "classList",
                meta: {
                  title: "班次列表"
                },
                component: () =>
                  import("@/views/apply/newVip/set/compose/index")
              },
              {
                path: "resultList",
                name: "resultList",
                meta: {
                  title: "排版列表"
                },
                component: () =>
                  import("@/views/apply/newVip/set/compose/result")
              }
            ]
          },
          {
            path: "sound",
            name: "sound",
            meta: {
              title: "音响设置"
            },
            component: () => import("@/views/apply/newVip/set/sound")
          },
          {
            path: "hardware",
            name: "hardware",
            meta: {
              title: "教学商城"
            },
            component: () => import("@/views/apply/newVip/set/hardware")
          },
          {
            path: "printer",
            name: "printer",
            meta: {
              title: "打印机设置"
            },
            component: () => import("@/views/apply/newVip/set/printer/index")
          },
          {
            path: "printList",
            name: "printList",
            meta: {
              title: "打印机设置"
            },
            component: () => import("@/views/apply/newVip/set/printer/list")
          },
          {
            path: "familyCard",
            name: "familyCard",
            meta: {
              title: "亲属卡设置"
            },
            component: () => import("@/views/apply/newVip/set/familyCard/set")
          },
          {
            path: "general",
            name: "general",
            meta: {
              title: "通用设置"
            },
            component: () => import("@/views/apply/newVip/set/general/index")
          },
          {
            path: "smsConfig",
            name: "smsConfig",
            meta: {
              title: "短信设置"
            },
            component: () => import("@/views/apply/newVip/set/smsConfig/index")
          },
          {
            path: "smsTemplate",
            name: "smsTemplate",
            meta: {
              title: "短信模板"
            },
            component: () =>
              import("@/views/apply/newVip/set/smsConfig/template")
          },
          {
            path: "safety_Set",
            name: "safety_Set",
            meta: {
              title: "安全设置"
            },
            component: () =>
              import("@/views/apply/newVip/set/smsConfig/safety_Set")
          },
          {
            path: "discountPast",
            name: "discountPast",
            meta: {
              title: "优惠券过期设置"
            },
            component: () =>
              import("@/views/apply/newVip/set/smsConfig/discountPast")
          },
          {
            path: "menuOptions",
            name: "menuOptions",
            meta: {
              title: "功能开关"
            },
            component: () =>
              import("@/views/apply/newVip/set/menuOptions/menuOptions")
          },
          {
            path: "replenishment",
            name: "replenishment",
            meta: {
              title: "补单"
            },
            component: () => import("@/views/apply/newVip/set/replenishment")
          },
          {
            path: "ruyiConfig",
            name: "ruyiConfig",
            meta: {
              title: "如意设置"
            },
            component: () => import("@/views/apply/newVip/set/ruyiConfig")
          },
          {
            path: "AccountSecurity",
            name: "AccountSecurity",
            meta: {
              title: "账号安全"
            },
            component: () => import("@/views/apply/newVip/set/AccountSecurity")
          }
        ]
      },
      {
        path: "center",
        name: "center",
        meta: {
          title: "会员中心"
        },
        component: {
          render: c => c("router-view")
        },
        redirect: "/apply/newVip/13/center/userList",
        children: [
          {
            path: "userList",
            name: "userList",
            meta: {
              title: "会员列表"
            },
            component: () => import("@/views/apply/newVip/user/userList")
          },
          {
            path: "userDetail",
            name: "userDetail",
            meta: {
              title: "会员详情"
            },
            component: () => import("@/views/apply/newVip/user/userDetail")
          },
          {
            //appid==387时可用
            path: "WateruserList",
            name: "WateruserList",
            meta: {
              title: "会员列表"
            },
            component: () => import("@/views/apply/newVip/user/WateruserList")
          },
          {
            path: "sign",
            name: "sign",
            meta: {
              title: "会员标签"
            },
            component: {
              render: c => c("router-view")
            },
            children: [
              {
                path: "userSign",
                name: "userSign",
                meta: {
                  title: "会员标签"
                },
                component: () =>
                  import("@/views/apply/newVip/user/sign/userSign")
              },
              {
                path: "adSign",
                name: "adSign",
                meta: {
                  title: "添加标签"
                },
                component: () => import("@/views/apply/newVip/user/sign/adSign")
              },
              {
                path: "SignDetails",
                name: "SignDetails",
                meta: {
                  title: "标签详情"
                },
                component: () =>
                  import("@/views/apply/newVip/user/sign/SignDetails")
              }
            ]
          },
          {
            //appid==387时可用
            path: "userBlacklist",
            name: "userBlacklist",
            meta: {
              title: "会员黑名单"
            },
            component: () => import("@/views/apply/newVip/user/userBlacklist")
          },
          {
            path: "import",
            name: "import",
            meta: {
              title: "会员导入"
            },
            component: () => import("@/views/apply/newVip/user/import")
          },
          {
            path: "assetTransfer",
            name: "assetTransfer",
            meta: {
              title: "会员资产转账"
            },
            component: () => import("@/views/apply/newVip/user/assetTransfer")
          },
          {
            path: "infor",
            name: "infor",
            meta: {
              title: "客户概况"
            },
            component: () => import("@/views/user/infor.vue")
          },
          // 客户管理
          // {
          //   path: "userManage/userInquire",
          //   name: "userInquire",
          //   meta: {
          //     title: "客户查询"
          //   },
          //   component: () => import("@/views/user/userManage/userInquire.vue")
          // },
          {
            path: "analyze",
            name: "analyze",
            meta: {
              title: "客户分析"
            },
            component: () => import("@/views/user/vipAnalyze/index.vue")
          },
          {
            path: "userManage/userCrowd",
            name: "userCrowd",
            meta: {
              title: "客户分群"
            },
            component: () => import("@/views/user/userManage/userCrowd.vue"),
            children: [
              {
                path: "sign",
                name: "sign",
                meta: {
                  title: "全部人群"
                },
                component: () =>
                  import("@/views/user/userManage/crowd/sign.vue")
              },

              {
                path: "classify",
                name: "classify",
                meta: {
                  title: "人群分类"
                },
                component: () =>
                  import("@/views/user/userManage/crowd/classify.vue")
              },
              {
                path: "record",
                name: "record",
                meta: {
                  title: "营销记录"
                },
                component: () =>
                  import("@/views/user/userManage/crowd/record.vue")
              }
            ]
          },
          {
            path: "userManage/adSign",
            name: "adSign",
            meta: {
              title: "新建人群"
            },
            component: () => import("@/views/user/userManage/crowd/adSign.vue")
          },
          {
            path: "userManage/userImport",
            name: "userImport",
            meta: {
              title: "客户导入"
            },
            component: () => import("@/views/user/userManage/userImport.vue")
          },
          {
            path: "userManage/labelManage",
            name: "labelManage",
            meta: {
              title: "标签管理"
            },
            component: () => import("@/views/user/userManage/labelManage.vue")
          },
          // 客户运营
          {
            path: "userOperation/crowdOperat",
            name: "crowdOperat",
            meta: {
              title: "人群运营"
            },
            component: () =>
              import("@/views/user/userOperation/crowdOperat.vue")
          },
          {
            path: "userOperation/addCrowdOperat",
            name: "addCrowdOperat",
            meta: {
              title: "操作人群运营"
            },
            component: () =>
              import("@/views/user/userOperation/addCrowdOperat.vue")
          },
          {
            path: "userOperation/sceneOperat",
            name: "sceneOperat",
            meta: {
              title: "场景运营"
            },
            component: () =>
              import("@/views/user/userOperation/sceneOperat.vue")
          }
        ]
      },
      {
        path: "refuel",
        name: "refuel",
        meta: {
          title: "加油管理"
        },
        component: {
          render: c => c("router-view")
        },
        redirect: "/apply/newVip/13/refuel/list",
        children: [
          {
            path: "list",
            name: "list",
            meta: {
              title: "油品列表"
            },
            component: () => import("@/views/apply/newVip/business/refuel/list")
          },
          {
            path: "adlist",
            name: "adlist",
            meta: {
              title: "添加油品"
            },
            component: () =>
              import("@/views/apply/newVip/business/refuel/adlist")
          },
          {
            path: "equipment",
            name: "equipment",
            meta: {
              title: "油枪管理"
            },
            component: () =>
              import("@/views/apply/newVip/business/refuel/equipment")
          },
          {
            path: "category",
            name: "category",
            meta: {
              title: "油品类别"
            },
            component: () =>
              import("@/views/apply/newVip/business/refuel/category")
          }
        ]
      },
      {
        path: "serve",
        name: "serve",
        meta: {
          title: "门店服务"
        },
        component: () => import("@/views/apply/newVip/business/refuel/serve")
      },
      {
        path: "carWash",
        name: "carWash",
        meta: {
          title: "洗车服务"
        },
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "shop",
            name: "shop",
            meta: {
              title: "洗车门店"
            },
            component: () => import("@/views/apply/newVip/carWash/shop")
          },
          {
            path: "adShop",
            name: "adShop",
            meta: {
              title: "添加洗车门店"
            },
            component: () => import("@/views/apply/newVip/carWash/adShop")
          },
          {
            path: "index",
            name: "index",
            meta: {
              title: "洗车项目"
            },
            component: () => import("@/views/apply/newVip/carWash/index")
          },
          {
            path: "seting",
            name: "seting",
            meta: {
              title: "添加洗车项目"
            },
            component: () => import("@/views/apply/newVip/carWash/seting")
          },
          {
            path: "order",
            name: "order",
            meta: {
              title: "洗车订单"
            },
            component: () => import("@/views/apply/newVip/carWash/order")
          },
          {
            path: "employee",
            name: "employee",
            meta: {
              title: "洗车员工"
            },
            component: () => import("@/views/apply/newVip/carWash/employee")
          },
          {
            path: "employeeAdd",
            name: "employeeAdd",
            meta: {
              title: "添加洗车员工"
            },
            component: () => import("@/views/apply/newVip/carWash/employeeAdd")
          }
        ]
      },
      {
        path: "card",
        name: "card",
        meta: {
          title: "卡项管理"
        },
        component: {
          render: c => c("router-view")
        },
        redirect: "/apply/newVip/13/card/levelGroup",
        children: [
          {
            path: "vip",
            name: "vip",
            meta: {
              title: "会员卡管理"
            },
            component: () => import("@/views/apply/newVip/card/vip/index") //旧版为index1
          },
          {
            path: "vipAdd",
            name: "vipAdd",
            meta: {
              title: "编辑会员卡"
            },
            component: () => import("@/views/apply/newVip/card/vip/add") //旧版为add1
          },
          {
            path: "vipAddNew",
            name: "vipAddNew",
            meta: {
              title: "编辑会员卡"
            },
            component: () => import("@/views/apply/newVip/card/vip/addnew") //旧版为add1
          },
          {
            path: "levelGroup",
            name: "levelGroup",
            meta: {
              title: "会员卡组列表"
            },
            component: () => import("@/views/apply/newVip/card/vip/levelGroup")
          },
          {
            path: "vipRecord",
            name: "vipRecord",
            meta: {
              title: "开卡记录"
            },
            component: () => import("@/views/apply/newVip/card/vip/record")
          },
          {
            path: "motorcade",
            name: "motorcade",
            meta: {
              title: "车队卡管理"
            },
            component: () => import("@/views/apply/newVip/card/motorcade/index")
          },
          {
            path: "motorcadeAdd",
            name: "motorcadeAdd",
            meta: {
              title: "编辑车队卡"
            },
            component: () => import("@/views/apply/newVip/card/motorcade/add")
          },
          {
            path: "motorcadeRecord",
            name: "motorcadeRecord",
            meta: {
              title: "开卡记录"
            },
            component: () =>
              import("@/views/apply/newVip/card/motorcade/record")
          },
          {
            path: "refule",
            name: "refule",
            meta: {
              title: "加油卡管理"
            },
            redirect: "refule/index",
            component: {
              render: c => c("router-view")
            },
            children: [
              {
                path: "index",
                name: "index",
                meta: {
                  title: "开卡"
                },
                component: () =>
                  import("@/views/apply/newVip/card/refule/index")
              },
              {
                path: "adrefule",
                name: "adrefule",
                meta: {
                  title: "添加加油卡"
                },
                component: () =>
                  import("@/views/apply/newVip/card/refule/adrefule")
              },
              {
                path: "refuleRecord",
                name: "refuleRecord",
                meta: {
                  title: "加油卡开卡记录"
                },
                component: () =>
                  import("@/views/apply/newVip/card/refule/record")
              }
            ]
          },
          {
            path: "activityCard",
            name: "activityCard",
            meta: {
              title: "活动卡项管理"
            },
            redirect: "activityCard/index",
            component: {
              render: c => c("router-view")
            },
            children: [
              {
                path: "index",
                name: "index",
                meta: {
                  title: "卡列表"
                },
                component: () =>
                  import("@/views/apply/newVip/card/activityCard/index")
              },
              {
                path: "set_card",
                name: "set_card",
                meta: {
                  title: "设置卡"
                },
                component: () =>
                  import("@/views/apply/newVip/card/activityCard/set_card")
              },
              {
                path: "card_detil",
                name: "card_detil",
                meta: {
                  title: "卡详情"
                },
                component: () =>
                  import("@/views/apply/newVip/card/activityCard/card_detil")
              },
              {
                path: "card_order_list",
                name: "card_order_list",
                meta: {
                  title: "卡订单"
                },
                component: () =>
                  import(
                    "@/views/apply/newVip/card/activityCard/card_order_list"
                  )
              },
              {
                path: "card_user_list",
                name: "card_user_list",
                meta: {
                  title: "用户平台卡"
                },
                component: () =>
                  import(
                    "@/views/apply/newVip/card/activityCard/card_user_list"
                  )
              },
              {
                path: "card_use_list",
                name: "card_use_list",
                meta: {
                  title: "使用记录"
                },
                component: () =>
                  import("@/views/apply/newVip/card/activityCard/card_use_list")
              }
            ]
          }
        ]
      },
      {
        path: "crossIndustry",
        name: "crossIndustry",
        meta: {
          title: "异业联盟"
        },
        redirect: "crossIndustry/index",
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "index",
            name: "index",
            meta: {
              title: "列表"
            },
            component: () =>
              import("@/views/apply/newVip/cross_industry_alliance/index")
          }
        ]
      },
      {
        path: "collection",
        name: "collection",
        meta: {
          title: "收款码管理"
        },
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "list",
            name: "list",
            meta: {
              title: "收款码管理"
            },
            component: () => import("@/views/apply/newVip/collection/list")
          }
        ]
      },
      {
        path: "pay",
        name: "pay",
        meta: {
          title: "支付"
        },
        redirect: "/apply/newVip/13/pay/index",
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "index",
            name: "index",
            meta: {
              title: "支付"
            },
            component: () => import("@/views/apply/newVip/pay/index")
          },
          {
            path: "null",
            name: "null",
            meta: {
              title: "支付账号设置"
            },
            redirect: "/apply/newVip/13/pay/null/person",
            component: () => import("@/views/apply/newVip/pay/home"),
            children: [
              {
                path: "weixin",
                name: "weixin",
                meta: {
                  title: "免签微信设置"
                },
                component: () => import("@/views/apply/newVip/pay/weixin")
              },
              {
                path: "zhifubao",
                name: "zhifubao",
                meta: {
                  title: "免签支付宝设置"
                },
                component: () => import("@/views/apply/newVip/pay/zhifubao")
              },
              {
                path: "yinlian",
                name: "yinlian",
                meta: {
                  title: "银联设置"
                },
                component: () => import("@/views/apply/newVip/pay/yinlian")
              },
              {
                path: "tonglian",
                name: "tonglian",
                meta: {
                  title: "通联设置"
                },
                component: () => import("@/views/apply/newVip/pay/tonglian")
              },
              {
                path: "balance",
                name: "balance",
                meta: {
                  title: "余额设置"
                },
                component: () => import("@/views/apply/newVip/pay/balance")
              },
              {
                path: "fuiou",
                name: "fuiou",
                meta: {
                  title: "富友设置"
                },
                component: () => import("@/views/apply/newVip/pay/fuiou")
              },
              // {
              //   path: "person",
              //   name: "person",
              //   meta: {
              //     title: "个人收款项设置"
              //   },
              //   component: () => import("@/views/apply/newVip/pay/person")
              // },
              // {
              //   path: "pay-set",
              //   name: "pay-set",
              //   meta: {
              //     title: "支付设置"
              //   },
              //   component: {
              //     render: c => c("router-view")
              //   },
              //   children: [
              //     {
              //       path: "offline",
              //       name: "offline",
              //       meta: {
              //         title: "线下消费"
              //       },
              //       component: () =>
              //         import("@/views/apply/newVip/pay/waySet/offline")
              //     },
              //     {
              //       path: "online",
              //       name: "online",
              //       meta: {
              //         title: "线上业务"
              //       },
              //       component: () =>
              //         import("@/views/apply/newVip/pay/waySet/online")
              //     }
              //   ]
              // },
              {
                path: "exclusion",
                name: "exclusion",
                meta: {
                  title: "优惠互斥设置"
                },
                component: () => import("@/views/apply/newVip/pay/exclusion")
              }
            ]
          },
          {
            path: "couponSetting",
            name: "couponSetting",
            meta: {
              title: "优惠互斥设置"
            },
            component: () => import("@/views/apply/couponSetting/couponSetting")
          }
        ]
      },
      {
        path: "generalize",
        name: "generalize",
        meta: {
          title: "推广"
        },
        component: () => import("@/views/apply/newVip/generalize")
      },
      {
        path: "report",
        name: "report",
        meta: {
          title: "报表"
        },
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "myList",
            name: "myList",
            meta: {
              title: "我的报表"
            },
            component: () => import("@/views/apply/newVip/report/list")
          },
          {
            path: "set",
            name: "set",
            meta: {
              title: "添加报表"
            },
            component: () => import("@/views/apply/newVip/report/set")
          }
        ]
      },
      {
        path: "motorcade",
        name: "motorcade",
        meta: {
          title: "车队管理"
        },
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "index",
            name: "index",
            meta: {
              title: "车队卡"
            },
            component: () => import("@/views/apply/newVip/motorcade/base/index")
          },
          {
            path: "adrefule",
            name: "adrefule",
            meta: {
              title: "操作车队卡"
            },
            component: () =>
              import("@/views/apply/newVip/motorcade/base/adrefule")
          },
          {
            path: "group",
            name: "group",
            meta: {
              title: "分组列表"
            },
            component: () => import("@/views/apply/newVip/motorcade/base/group")
          },
          {
            path: "list",
            name: "list",
            meta: {
              title: "车队列表"
            },
            component: () => import("@/views/apply/newVip/motorcade/base/list")
          },
          {
            path: "audit",
            name: "list",
            meta: {
              title: "待审核列表"
            },
            component: () => import("@/views/apply/newVip/motorcade/base/audit")
          },
          {
            path: "set",
            name: "set",
            meta: {
              title: "车队设置"
            },
            component: {
              render: c => c("router-view")
            },
            children: [
              {
                path: "rank",
                name: "rank",
                meta: {
                  title: "车队级别"
                },
                component: () =>
                  import("@/views/apply/newVip/motorcade/set/rank")
              },
              {
                path: "seting",
                name: "seting",
                meta: {
                  title: "车队设置"
                },
                component: () =>
                  import("@/views/apply/newVip/motorcade/set/seting")
              }
            ]
          }
        ]
      }
    ]
  }
];
